<template>
	<BaseCmsPage v-slot="{page}" @load="onPageLoad">
		<CmsPageLayout>
			<template #breadcrumb_section>
				<CmsBreadcrumbs v-if="page?.breadcrumbs" :items="page.breadcrumbs" />
			</template>

			<template #main_header>
				<div class="main-header" :class="{'bg-img': page?.main_image_upload_path}" :style="page?.main_image ? { background: 'url(' + absoluteImagePath(page?.main_image_upload_path) + ') no-repeat' } : ''">
					<div class="wrapper">
						<h1 v-if="page?.title">{{ page.title }}</h1>
					</div>
				</div>
			</template>

			<div v-if="page?.content" v-html="page.content" v-interpolation />

			<template #share_mobile>
				<CmsShare v-if="mobileBreakpoint" />
			</template>

			<template #share>
				<CmsShare v-if="!mobileBreakpoint" />
			</template>
		</CmsPageLayout>
	</BaseCmsPage>
</template>

<script setup>
	const {absoluteImagePath} = useText();
	const {mobileBreakpoint} = inject('rwd');

	//gtm
	const gtm = useGtmBB();

	function onPageLoad(data) {
		if(!data) return;
		gtm.pageView({
			url: data?.url || '',
			title: data?.title || '',
		});
	}
</script>
